import React, { useEffect, useState } from 'react';
import { apiService } from '../../services/api';
import planApi from '../../services/planApi';
import MainLayout from '../layout/MainLayout';
import Availability from '../plan/Availability';
import '../../styles/mentee-dashboard.scss';
import '../plan/plan.scss';

const MenteeSessions: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [relId, setRelId] = useState<number | null>(null);
  const [consentOk, setConsentOk] = useState(false);

  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const load = async () => {
    try {
      setLoading(true);
      const dResp = await apiService.mentee.dashboard();
      const id = dResp.data?.data?.active_relationship?.id || null;
      setRelId(id);
      if (id) {
        const p = await planApi.getPlan(id);
        setConsentOk(!!(p as any)?.locks?.fodaEnabled);
      }
    } catch {
      setRelId(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <div className="mentee-dashboard sessions-view">
        <div className="sv-eyebrow">Mentee</div>
        <h1 className="sv-title">Mis <em>Sesiones</em></h1>
        <p className="sv-lead">Registra todos los espacios de conversación con tu mentor.</p>

        <div className="sessions-page">
          {loading ? (
            <p className="dash-empty">Cargando sesiones…</p>
          ) : !relId ? (
            <p className="dash-empty">Aún no tienes una dupla activa. Cuando se asigne tu mentor, podrás agendar sesiones aquí.</p>
          ) : (
            <Availability relId={relId} role="mentee" consentOk={consentOk} onChanged={load} />
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default MenteeSessions;
